import React from 'react';
import styles from './Arrows.module.scss';
import KeyboardArrowLeftRoundedIcon from '@material-ui/icons/KeyboardArrowLeftRounded';
import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import {When} from 'react-if';

interface IArrowsProps {
  onRightClick?: () => void;
  onLeftClick?: () => void;
  hideRight?: boolean;
  hideLeft?: boolean;
}

const Arrows = (props: IArrowsProps) => (
  <div className={styles.Arrows}>
    <When condition={!props.hideRight}>{() =>
      <KeyboardArrowRightRoundedIcon onClick={props.onRightClick} className={styles.right}/>}
    </When>
    <When condition={!props.hideLeft}>{() =>
      <KeyboardArrowLeftRoundedIcon onClick={props.onLeftClick} className={styles.left}/>}
    </When>
  </div>
);

Arrows.defaultProps = {
  hideRight: false,
  hideLeft: false,
};

export default React.memo(Arrows)
